export const messages = {
  en: {
    addMenuGroup: {
      title: 'Add Menu Group',
      groupName: 'Group Name',
      groupNamePlaceholder: 'Required, please enter group name',
      groupNameRequired: 'Group name is required',
      iconPlaceholder: 'Required, please enter icon',
      iconRequired: 'Icon is required',
      label: 'Label',
      labelPlaceholder: 'Optional, please select label',
      seq: 'Sequence',
      seqPlaceholder: 'Required, please enter sequence',
      seqRequired: 'Sequence is required',
      groupType: 'Group Type',
      groupTypePlaceholder: 'Optional, please select group type',
      storeType: 'Store Type',
      storeTypePlaceholder: 'Please select store type',
      description: 'Description',
      descriptionPlaceholder: 'Optional, please enter description',
      web: 'WEB',
      app: 'APP',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      devTeam: 'Development Team'
    }
  },
  zh: {
    addMenuGroup: {
      title: '添加菜单组',
      groupName: '组名称',
      groupNamePlaceholder: '必填，请填写组名称',
      groupNameRequired: '组名称不能为空',
      iconPlaceholder: '必填，请填写图标',
      iconRequired: '图标不能为空',
      label: '标签',
      labelPlaceholder: '选填，请选择标签',
      seq: '序列',
      seqPlaceholder: '必填，请填写序列',
      seqRequired: '序列不能为空',
      groupType: '组类型',
      groupTypePlaceholder: '选填，请选择组类型',
      storeType: '归属商户',
      storeTypePlaceholder: '请选择商户类型',
      description: '描述',
      descriptionPlaceholder: '选填，请填写描述',
      web: 'WEB端',
      app: 'APP端',
      operationTeam: '运营团队',
      merchant: '商家',
      devTeam: '开发团队'
    }
  }
}